export default
    {
        guardaTemp:'/ortopac/guardaTemp',
        listTemp:'/ortopac/listTemp',
    }
